import { render, staticRenderFns } from "./FriendlyUrl.vue?vue&type=template&id=1abea06e&scoped=true"
import script from "./FriendlyUrl.vue?vue&type=script&lang=js"
export * from "./FriendlyUrl.vue?vue&type=script&lang=js"
import style0 from "./FriendlyUrl.vue?vue&type=style&index=0&id=1abea06e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1abea06e",
  null
  
)

export default component.exports